import {useState, useEffect} from "react";
import "./ThemeToggle.css";
import {useTheme} from "../../../hooks/useTheme";
import {ReactComponent as SwitcherLight} from "../../../assets/svg/switcher_light.svg";
import {ReactComponent as SwitcherDark} from "../../../assets/svg/switcher_dark.svg";


const VISIBLE_MAX_SCROLL_Y = 120;


export default function ThemeToggle() {
  const {theme, toggleTheme} = useTheme();
  const isDark = theme === "dark";

  // Only shown near the top of the page; hidden once scrolled past the threshold.
  const [visible, setVisible] = useState(() => window.scrollY < VISIBLE_MAX_SCROLL_Y);


  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY < VISIBLE_MAX_SCROLL_Y);

    onScroll();
    window.addEventListener("scroll", onScroll, {passive: true});
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  return (
    <button
      className={`theme-toggle ${theme} ${visible ? "" : "theme-toggle--hidden"}`}
      onClick={toggleTheme}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <SwitcherLight
        className="theme-toggle-bg theme-toggle-bg-light"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      />
      <SwitcherDark
        className="theme-toggle-bg theme-toggle-bg-dark"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      />
    </button>
  );
}
